import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '../utils/cn';

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...rest }, ref) => (
    <label
      ref={ref}
      className={cn(
        'text-biz-sm font-medium text-biz-foreground',
        'block mb-biz-content',
        className,
      )}
      {...rest}
    />
  ),
);
Label.displayName = 'Label';
